import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, InputAdornment } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'

const useStyles = makeStyles((theme) => ({
    dialogActions: {
        justifyContent: 'flex-start'
    },
    fieldWrapper: {
        '& .MuiTextField-root': { minWidth: '378px', marginBottom: '16px' }
    },
    summaryHeader: {
        fontSize: '12px',
        color: '#1A1A35',
        fontWeight: '800',
        opacity: '.75'
    },
    text: {
        color: '#1A1A35',
        fontSize: '14px'
    }
}))

const SpecialRenewalDialog = (props) => {
    const classes = useStyles()
    let { isShown, setIsShown, updateMembership, membership } = props
    const [specialRenewalPrice, setSpecialRenewalPrice] = useState('')
    const [specialRenewalNumber, setSpecialRenewalNumber] = useState('1')

    useEffect(() => {
        if (membership && membership._id) {
            setSpecialRenewalPrice(membership.special_renewal_price ? (membership.special_renewal_price / 100).toFixed(2) : '')
            setSpecialRenewalNumber(membership.special_renewal_number || '')
        }
    }, [membership])

    const saveMembership = () => {
        const updates = {
            ...membership,
            special_renewal_price: specialRenewalPrice ? Math.round(parseFloat(specialRenewalPrice) * 100) : null,
            special_renewal_number: specialRenewalNumber ? parseInt(specialRenewalNumber) : null,
            special_renewal_times_renewed: membership.special_renewal_times_renewed || 0
        }

        updateMembership(updates)
        setIsShown(false)
    }

    return (
        <Dialog
            open={isShown}
            className={classes.dialog}
            onClose={() => setIsShown(false)}
            PaperProps={{
                style: {
                    minWidth: '500px',
                    maxWidth: '500px',
                    width: '500px'
                }
            }}>
            <DialogTitle
                style={{
                    marginBottom: 24
                }}>
                Special Renewal Settings
            </DialogTitle>
            <DialogContent className={classes.fieldWrapper}>
                <TextField
                    variant="filled"
                    label="Special Renewal Price (in dollars)"
                    type="number"
                    value={specialRenewalPrice}
                    onChange={(e) => setSpecialRenewalPrice(e.target.value)}
                    helperText="Enter the special price for renewals (in dollars, e.g., 99.99)"
                    fullWidth
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                    }}
                />
                <TextField
                    variant="filled"
                    label="Special Renewal Number Limit"
                    type="number"
                    value={specialRenewalNumber}
                    onChange={(e) => setSpecialRenewalNumber(e.target.value)}
                    helperText="Number of times the special price should apply"
                    fullWidth
                />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    variant="contained"
                    onClick={saveMembership}
                    color="secondary">
                    Save
                </Button>
                <Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
                    CANCEL
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SpecialRenewalDialog
